import "core-js/modules/es6.array.is-array";

/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import RehypeReact from 'rehype-react';
import LatestPost from '../components/post_latest';
import PostTabs from '../components/post_tabs';
import PostSlide from '../components/post_slide';
import PostCard from '../components/post_card';
import { addComponents } from './xmark/components';

function UserScript(_ref) {
  var _ref$async = _ref.async,
      async = _ref$async === void 0 ? false : _ref$async,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;
  useEffect(function () {
    var isScriptValid = false;
    var script = document.createElement('script');
    script.async = async;

    if (src) {
      script.src = src;
      isScriptValid = true;
    } else if (Array.isArray(children) && children.length > 0) {
      isScriptValid = true;
      script.innerHTML = children.join(';');
    }

    if (isScriptValid) {
      document.body.appendChild(script);
      return function () {
        document.body.removeChild(script);
      };
    }

    return function () {};
  }, []);
  return null;
}

var components = addComponents({
  'latest-post': LatestPost,
  'post-tabs': PostTabs,
  'post-slide': PostSlide,
  'post-card': PostCard,
  script: UserScript
});

function createElement(component, props, children) {
  var Component = components && component && components[component] || // Get component from map if present
  component || // Otherwise just the string
  'div'; // Default to div
  // And return the formed component

  return /*#__PURE__*/React.createElement(Component, props, children);
}

export default new RehypeReact({
  createElement: createElement
}).Compiler;